import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/api/query-keys';

import {
  getBrowseTeams,
  getOrganizationDetails,
  getOrganizationInvitations,
  getOrganizationMembers,
  getSsoDomains,
  getSsoProviders,
} from './organization-settings-server';

const key = (organizationId: string, page: string) =>
  [...queryKeys.workspaceSettings.organization(organizationId), page] as const;

export function organizationDetailsQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: key(organizationId, 'details'),
    queryFn: () => getOrganizationDetails(),
  });
}

export function browseTeamsQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: key(organizationId, 'teams'),
    queryFn: () => getBrowseTeams(),
  });
}

export function organizationMembersQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: key(organizationId, 'members'),
    queryFn: () => getOrganizationMembers(),
  });
}

export function organizationInvitationsQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: key(organizationId, 'invitations'),
    queryFn: () => getOrganizationInvitations(),
  });
}

export function ssoProvidersQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: key(organizationId, 'sso-providers'),
    queryFn: () => getSsoProviders(),
  });
}

export function ssoDomainsQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: key(organizationId, 'sso-domains'),
    queryFn: () => getSsoDomains(),
  });
}
